export const getIsAvailableInStore = (availability) => {
    if (!availability || availability?.length === 0) {
        // No availability information, we cannot say anything more about it.
        return undefined;
    }
    // Consider available if every item in the design is available
    return availability.every(item => item.content.availableForCashCarry);
};
export const getIsAvailableForZip = (availability) => {
    if (!availability || availability?.length === 0) {
        // No availability information, we cannot say anything more about it.
        return undefined;
    }
    // Consider available if every item in the design is available
    return availability.every(item => item.content.availableForHomeDelivery);
};
//# sourceMappingURL=availability.js.map